import u from 'jquery';
import { Effects } from './effects';
import { Rain } from './Effects/Rain';
import * as QueryLoader2 from './ql';
import { animateBulb, animate } from './animations';
import { Routing } from './routing';


export class Loader {
  static init() {
    // Routing.change(document.location.pathname);
    // return;
    window.addEventListener('DOMContentLoaded', () => {
      animateBulb('.loader');
      QueryLoader2(document.querySelector('body'), {
        deepSearch: true,
        backgroundColor: false,
        barColor: false,
        minimumTime: 2500,
        percentage: false,
        onProgress: function (percentage) {
          percentage = Math.round(percentage);
          u('.loader-progress').width(`${percentage}%`);
        },
        onComplete: function () {
          animate.init();
          setTimeout(()=>{
            Routing.change(document.location.pathname);
          }, 200);
        }
      });
      if (u('#intro').length > 0) {
        const effects = new Effects();
        effects.run('ash');
        const rain = new Rain('#effect-bg');
        rain.run();
      }
    });
  }
}
